import {
  GATE_TABS,
  gateLabel,
  type GateLabelKey,
  type GateTab,
} from "@nexseed/shared";
import { useAuth } from "@/features/auth/store";

/**
 * The Gate module's names as this login's roles call them (`roles.gate_labels`): the arrival desk
 * reads Inward Pending as "Yet to Arrive". Display only; tab codes and URLs keep their names.
 */
export function useGateLabel(): (key: GateLabelKey) => string {
  const labels = useAuth((s) => s.me?.gateLabels);
  return (key) => gateLabel(labels, key);
}

/**
 * The Gate tabs this login's roles show (`roles.gate_tabs`), in tab order. The server refuses the
 * others; an API from before the setting existed sends none, which means every tab.
 */
export const visibleGateTabs = (tabs: readonly GateTab[] | null | undefined) =>
  tabs?.length ? tabs : GATE_TABS;

export function useGateTabs(): readonly GateTab[] {
  const tabs = useAuth((s) => s.me?.gateTabs);
  return visibleGateTabs(tabs);
}
